import { useNavigate, useLocation } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

/**
 * A "back" affordance that actually goes back to wherever the user came
 * from (browser history), instead of always landing on one fixed page —
 * so it does the right thing whether someone arrived from a category,
 * search, the wishlist, or wherever else a product/page can be reached
 * from. Falls back to a fixed destination only when there's nothing to
 * go back to (e.g. a shared link opened directly), which React Router
 * tells us via location.key === "default" on the very first page of a
 * session.
 */
export default function BackButton({ fallback = "/", fallbackLabel = "Back", className = "" }) {
  const navigate = useNavigate();
  const location = useLocation();
  const canGoBack = location.key !== "default";

  return (
    <button
      type="button"
      onClick={() => (canGoBack ? navigate(-1) : navigate(fallback))}
      className={`inline-flex items-center gap-1 text-sm text-ink-light ${className}`}
    >
      <ChevronLeft size={16} /> {canGoBack ? "Back" : fallbackLabel}
    </button>
  );
}
